import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Componente que resetea la posición del scroll a la parte superior
 * cada vez que cambia la ruta en la aplicación
 */
const ScrollReset = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Cuando cambia la ruta, hacer scroll a la parte superior
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Este componente no renderiza nada
};

export default ScrollReset;